import { render, staticRenderFns } from "./Prospects.vue?vue&type=template&id=2156f398&scoped=true&"
import script from "./Prospects.vue?vue&type=script&lang=js&"
export * from "./Prospects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2156f398",
  null
  
)

export default component.exports